<template>
    <div class="notice">
        <div class="session-title">2025年度{{ mecoTitle }}执业资格考试</div>
        <header class="main-title">
            <p>{{ nTitle }}</p>
        </header>
        <section>
            <!--考生须知-->
            <div class="exam-rules-page page" :style="dialogVisible == 1 ? 'display: block;' : 'display: none;'">
                <div class="ct">
                    <div class="content" v-html="descText.content"></div>
                </div>
                <div class="btn-group">
                    <div class="pop-sure" style="text-align: center;">
                        <el-checkbox v-model="checked" :true-label="1" :false-label="0">我已阅读</el-checkbox>
                    </div>
                    <div class="btn-list">
                        <!--<div class="prev-step btn default-btn btn">上一步</div>-->
                        <div @click="nextTick"
                            :class="checked == 0 ? 'next-step btn default-btn btn disabled-btn' : 'next-step btn default-btn btn'"
                            id="exam-rules_next_btn">开始考试</div>
                    </div>
                </div>
            </div>
        </section>
    </div>

</template>

<script>
export default {
    data() {
        return {
            nums: 9,
            dialogVisible: 1,
            checked: 0,
            isAuto: false,
            nTitle: "考生须知",
            mecoId: sessionStorage.getItem("access-mecoId"),
            column_id: sessionStorage.getItem("access-column_id"),
            paper_id: 0,
            mecoTitle: '',
            descText: '',
        };
    },
    mounted: function () {
        var that = this;
        this.mecoTitle = sessionStorage.getItem("access-mecoName");
        var query = that.$route.query;
        if (query.paper_id) {
            that.paper_id = query.paper_id;
        }
        this.getAgreement();
        this.getList();
    },
    methods: {

        getAgreement() {
            let that = this;
            let formData = {};
            let id = 17;
            let column_id = sessionStorage.getItem("access-column_id");
            if (column_id == 65 || column_id == 66) {
                id = 19;
            } else if (column_id == 77) {
                id = 18;
            }
            formData.id = id;
            that.axios.post("/getHelpsDetails", formData).then((res) => {
                if (res) {
                    that.descText = res.data;
                }
            });
        },

        getList() {
            let that = this;
            let formData = {};
            formData.column_id = that.column_id;
            formData.subject_id = that.mecoId;
            formData.paper_id = that.paper_id;
            that.axios.post("/getPaperMeco", formData).then((res) => {
                if (res) {
                    that.pc = res.data.pc;
                    that.pc_id = res.data.pc_id;
                    sessionStorage.setItem("access-mecoPapers", JSON.stringify(res.data));
                }
            });
        },

        nextTick() {
            if (this.checked == 0) {
                this.$message.warning("请先阅读协议");
                return false;
            } else {
                this.goQuestion();
            }
        },

        goQuestion() {
            this.$router.push("/guide/ces/question");
        },
    },
};
</script>

<style scoped>
.notice ::-webkit-scrollbar {
    width: 11px;
    height: 11px;
    position: relative;
    left: 10px;
}

.notice ::-webkit-scrollbar-thumb {
    background-color: #606d71;
    background-clip: padding-box;
    min-height: 28px;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
}

.notice {
    width: 100%;
    height: 100vh;
    background-color: #EDF6FD;
}

.notice .session-title {
    padding: 0 0 0 20px;
    margin: 0;
    background: #0077FF;
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
    height: 48px;
    line-height: 48px;
    text-align: left;
}

.notice .main-title {
    width: 100%;
    height: 75px;
    line-height: 90px;
}

.notice .main-title p {
    font-size: 36px;
    text-align: center;
}

.notice section {
    background: #fff;
    width: 70%;
    height: calc(85% - 60px);
    margin-top: 50px;
    min-height: 610px;
    min-width: 1000px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    box-shadow: 0 0 20px 0 rgba(171, 178, 219, 0.5);
    transition: all 0.3s;
}

.notice section>.page {
    display: none;
    width: 100%;
    height: 100%;
}

.notice .covid-19-confirm-page,
.notice .exam-rules-page,
.notice .wait-start-exam-page {
    position: relative;
}

.notice .covid-19-confirm-page .ct,
.notice .exam-rules-page .ct,
.notice .wait-start-exam-page .ct {
    border-radius: 6px;
    overflow-y: scroll;
    position: absolute;
    top: 30px;
    left: 30px;
    right: 30px;
    bottom: 80px;
    margin: 1.5rem;
}

.notice .exam-rules-page .ct *,
.notice .covid-19-confirm-page .ct * {
    all: revert;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .list-item ul li {
    margin-bottom: 2rem;
}

ul,
ol,
li {
    list-style: none;
}

.notice .covid-19-confirm-page .btn-group,
.notice .exam-rules-page .btn-group,
.notice .wait-start-exam-page .btn-group {
    height: 80px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.notice .covid-19-confirm-page .btn-group .pop-sure,
.notice .exam-rules-page .btn-group .pop-sure,
.notice .wait-start-exam-page .btn-group .pop-sure {
    text-align: center;
    margin: 0 0 10px 0;
    position: absolute;
    top: 30px;
    right: 80px;
}

.pop-sure {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.notice .covid-19-confirm-page .btn-group .btn-list,
.notice .exam-rules-page .btn-group .btn-list,
.notice .wait-start-exam-page .btn-group .btn-list {
    display: flex;
}

.btn {
    position: relative;
    display: inline-block;
    margin: 0 0.8rem !important;
    vertical-align: middle !important;
    padding: 8px 30px;
    color: #000;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s;
}

.default-btn,
.btn-primary {
    background: #447dff;
    color: #fff;
}

.cancel-btn,
.disabled-btn {
    background: #8c93ac;
    color: #fff;
}

.notice .instructions-page .operation-intro {
    width: 100%;
    height: 100%;
}

.notice .instructions-page .operation-intro .ct {
    width: 100%;
    height: 100%;
    display: block;
    background: #fff;
    position: relative;
    border-radius: 6px;
}

.notice .instructions-page .operation-intro .ct .info {
    /* width: 100%; */
    /* height: 93%; */
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 1.5rem 0 1.5rem;
    margin: 0 auto;
    position: absolute;
    top: 30px;
    left: 30px;
    right: 30px;
    bottom: 80px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area {
    width: 100%;
    padding-bottom: 1.5rem;
    height: 100%;
    position: relative;
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .list-show {
    padding-right: 240px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt {
    width: 100%;
    height: 100%;
    display: block;
    overflow-x: hidden;
    overflow-y: scroll;
    box-shadow: inset 2px 2px 11px -1px #abb2db, inset -2px -2px 11px -1px #abb2db;
    padding: 30px;
    border-radius: 6px;
}

.notice .instructions-page .operation-intro .ct .info .list-show .rt {
    right: 0;
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt {
    width: 240px;
    height: 100%;
    position: absolute;
    top: 0;
    padding: 1rem 0 1rem 60px;
}

.notice .instructions-page .operation-intro .ct .btn-list {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}

.notice .instructions-page .operation-intro .ct .info .list-show .rt .intro-lt-btn {
    left: -0.5px;
}

.notice .instructions-page .operation-intro .ct .info .top-info-area {
    width: 100%;
    height: 95px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page {
    margin-bottom: 50px;
}

.notice .instructions-page .page-h-tag {
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .top-info-area p {
    font-weight: bolder;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .title {
    color: #3279ff;
    font-size: 1.2rem;
    margin-bottom: 1.8rem;
    font-weight: bolder;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page>div {
    padding-right: 1rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .list-item ul li {
    margin-bottom: 2rem;
}


.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-lt-btn {
    transition: all 0.3s;
    width: 14px;
    height: 80px;
    display: block;
    background: #307aff;
    position: absolute;
    top: 50%;
    margin-top: -40px;
    opacity: 0.6;
    border-radius: 0 20px 20px 0;
    cursor: pointer;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list {
    width: 180px;
    height: 185px;
    position: relative;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-lt-btn:before {
    width: 18px;
    height: 18px;
    display: block;
    position: absolute;
    top: 50%;
    left: -2px;
    margin-top: -9px;
}

.notice .instructions-page .operation-intro .ct .info .list-show .rt .intro-lt-btn:before {
    content: "";
    background: url(../../../../public/images/guide/right_iconfont.png);
    background-size: cover;
}

.notice .instructions-page .operation-intro .ct .info .list-hide .rt .intro-lt-btn:before {
    content: "";
    background: url(../../../../public/images/guide/left_iconfont.png);
    background-size: cover;
}

.notice .instructions-page .operation-intro .ct .info .list-hide {
    padding-right: 0;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list .list-line {
    width: 4px;
    height: 100%;
    background: #ccceda;
    display: block;
    position: absolute;
    left: -2.1rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul {
    padding: 1rem 0;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list .list-line .top-point {
    top: -1rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list .list-line .line-point {
    width: 1rem;
    height: 1rem;
    background: #fff;
    border: 0.2rem solid #ccceda;
    border-radius: 2rem;
    position: absolute;
    left: 50%;
    margin-left: -0.5rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list .list-line .bottom-point {
    bottom: -1rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list .list-line .line-point {
    width: 1rem;
    height: 1rem;
    background: #fff;
    border: 0.2rem solid #ccceda;
    border-radius: 2rem;
    position: absolute;
    left: 50%;
    margin-left: -0.5rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li {
    height: 2.2rem;
    line-height: 2.2rem;
    position: relative;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li .select-tag {
    width: 1.5rem;
    height: 1rem;
    display: block;
    background: #307aff;
    clip-path: polygon(80% 0, 100% 50%, 80% 100%, 0 100%, 0% 50%, 0 0);
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li .tag {
    position: absolute;
    top: 50%;
    margin-top: -0.5rem;
    left: -2.45rem;
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li div {
    display: inline-block;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li .select-tag+.text {
    color: #307aff !important;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li .text {
    cursor: pointer;
    font-weight: bolder;
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .list-hide .rt {
    right: -288px;
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .list-hide .rt .intro-lt-btn {
    left: -49.5px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .list-item ul li>.list-item-info {
    display: flex;
}

.notice .instructions-page .span-blue {
    color: #447dff;
    margin-right: 10px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .big-img {
    width: 80%;
    max-width: 1024px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .page-img {
    display: block;
    margin: 2rem auto;
}

.notice .covid-19-confirm-page .wait-ct,
.notice .exam-rules-page .wait-ct,
.notice .wait-start-exam-page .wait-ct {
    box-shadow: none;
    border: none;
    display: flex;
    justify-content: center;
    background: #fff;
    align-items: center;
    flex-direction: column;
}

.notice .covid-19-confirm-page .start-exam .title,
.notice .exam-rules-page .start-exam .title,
.notice .wait-start-exam-page .start-exam .title {
    color: #36adb4;
}

.notice .covid-19-confirm-page .wait-ct .title,
.notice .exam-rules-page .wait-ct .title,
.notice .wait-start-exam-page .wait-ct .title {
    font-size: 58px;
    letter-spacing: 10px;
    margin-top: 58px;
}

.notice .covid-19-confirm-page .wait-ct .logo img,
.notice .exam-rules-page .wait-ct .logo img,
.notice .wait-start-exam-page .wait-ct .logo img {
    width: 100px;
    height: 100px;
}

.notice .covid-19-confirm-page .wait-ct .intro,
.notice .exam-rules-page .wait-ct .intro,
.notice .wait-start-exam-page .wait-ct .intro {
    font-size: 24px;
    color: #000;
    margin-top: 80px;
    text-align: center;
}

.notice .covid-19-confirm-page .wait-ct .intro p,
.notice .exam-rules-page .wait-ct .intro p,
.notice .wait-start-exam-page .wait-ct .intro p {
    margin-top: 10px;
}
</style>
